import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { router } from 'modules/common/utils';
import { Icon, DropdownToggle } from 'modules/common/components';
import { PerPageButton, Option } from './styles';
import { ButtonToolbar, Dropdown, MenuItem } from 'react-bootstrap';

// per page chooser component
const ReportPerPageChooser = (
  { history, perPage, onPerPageChooser },
  { __ }
) => {
  const currentPerPage = perPage;

  const onClick = perPage => {
    onPerPageChooser(perPage);
  };

  const renderOption = number => {
    return (
      <MenuItem onClick={() => onClick(number)}>
        {number}
      </MenuItem>
    );
  };

  return (
    <span>
      <Dropdown id="per-page-chooser" className="dropup">
        <DropdownToggle bsRole="toggle">
          <PerPageButton className='d-flex justify-content-between align-items-center'>
            {/* {currentPerPage} {__('per page')} <Icon icon="uparrow-2" /> */}
            <span>{currentPerPage}</span>
            {/* <Icon icon="downarrow-2" /> */}
            <span className="material-symbols-outlined">
              expand_more
            </span>
          </PerPageButton>
        </DropdownToggle>
        <Dropdown.Menu>
          {renderOption(10)}
          {renderOption(20)}
          {renderOption(30)}
          {renderOption(50)}
          {renderOption(100)}
          {renderOption(200)}
        </Dropdown.Menu>
      </Dropdown>
      {/* <ButtonToolbar>
        <Dropdown id="dropdown-custom-1">
          <Dropdown.Toggle>
            <PerPageButton>
              {currentPerPage} <Icon icon="downarrow-2" />
            </PerPageButton>
          </Dropdown.Toggle>
          <Dropdown.Menu className="super-colors">
            {renderOption(10)}
            {renderOption(20)}
            {renderOption(30)}
            {renderOption(50)}
            {renderOption(100)}
            {renderOption(200)}
          </Dropdown.Menu>
        </Dropdown>
      </ButtonToolbar> */}
    </span>
  );
};

ReportPerPageChooser.propTypes = {
  history: PropTypes.object.isRequired
};

ReportPerPageChooser.contextTypes = {
  __: PropTypes.func
};

export default withRouter(ReportPerPageChooser);



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/reportPagination/ReportPerPageChooser.js